import { $wgsl } from '../../wgsl-preprocessor/wgsl-preprocessor';
import wboitChunk from '../chunks/wboit.wgsl';
import edgeSource from './edge.wgsl';
import { getModelMatrixHook } from './modelMatrixHook';

import { FrameBindGroup } from './FrameBindGroup';
import { getObjectUniformsDeclaration } from './uniforms/ObjectUniforms';
import { getMaterialUniformsDeclaration } from './MaterialUniforms';
import { getVertexTransformChunk } from '../chunks/vertex_transform';

export function getEdgeShader(hasInstanceIdMap, useWboit, useUnorm16 = false) {
  return $wgsl(edgeSource, {
    frameBindGroup: FrameBindGroup.getDeclaration(0),
    objectUniforms: getObjectUniformsDeclaration(1, hasInstanceIdMap),
    modelMatrixHook: getModelMatrixHook(),
    materialUniforms: getMaterialUniformsDeclaration(2),
    vertexTransform: getVertexTransformChunk(),
    useWboit, wboitChunk: useWboit ? wboitChunk : '',
    useUnorm16
  });
}